import { useState } from 'react';
import { useAgentPermission } from '@entities/user';
import { useActiveProjectContext } from '@shared/hooks/useActiveProjectContext';
import { Button } from '@shared/ui/Button';
import { IconPlus } from '@shared/ui/icons';
import { SchemeRegistry } from '@widgets/GeoSchemes';
import { NewSchemeDialog } from './NewSchemeDialog';

/**
 * Индекс раздела — реестр исполнительных схем. Отклонённые ПТО или заказчиком
 * подсвечены «Требует корректировки» с причиной.
 */
export function GeodesySchemes() {
  const { can_write } = useAgentPermission('geodesy');
  const { activeProjectId } = useActiveProjectContext();
  const [creating, setCreating] = useState(false);

  return (
    <>
      <SchemeRegistry
        linkBase="/agents/geodesy/schemes"
        audience="geodesist"
        activeProjectId={activeProjectId || undefined}
        actions={
          can_write ? (
            <Button type="button" $variant="primary" onClick={() => setCreating(true)}>
              <IconPlus size={16} /> Новая ИС
            </Button>
          ) : undefined
        }
        emptyText={
          can_write
            ? 'Схем по выбранным фильтрам нет. Создайте новую или откройте заявку во вкладке «Заявки».'
            : 'Схем по выбранным фильтрам нет.'
        }
      />
      {creating && <NewSchemeDialog onClose={() => setCreating(false)} />}
    </>
  );
}
